import { IconCheck, IconClose, IconLeftCaret } from "components/icons/Icons";
import React, { useState } from "react";

import DecorativeImage from "components/decorative-image/DecorativeImage";
import { DelayTimer } from "consts";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "micro-i18n";
import { isNullOrUndef } from "utils";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/results/OptionResultItem.scss';

const OptionResultItem = ({ option, isActive }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { text, percent, answered, quiz, img, imgAlt } = option;
  const percentStyle = { width: isNaN(percent) ? 0 : `${percent}%` };
  const percentClass = `csw-option-result-item-percent-${percent} ${isLoaded ? "csw-loaded" : "csw-loading"}`;
  const answeredClass = answered ? "option-answered" : "option-not-answered";
  const isQuiz = !isNullOrUndef(quiz);
  const isCorrect = isQuiz && quiz.correct;
  const quizClass = isQuiz ? "quiz-result-option" : "result-option";
  const fillClass = isQuiz ? (isCorrect ? "option-fill-correct" : "option-fill-incorrect") : "option-fill";

  setTimeout(() => setIsLoaded(isActive), DelayTimer.ResultItemAnimMS);

  return (
    <div
      className={classNames("csw-option-result-item outline", percentClass, quizClass, answeredClass)}
      tabIndex="0"
      aria-label={i18n.t(answered ? "RESULT_ANSWERED_LBL" : "RESULT_NOT_ANSWERED_LBL", { percent, text })}
    >
      <div className="csw-option-result-item-bar">
        <div className="csw-option-result-item-fill-wrapper" style={percentStyle}>
          <div className={classNames("csw-option-result-item-fill", fillClass)}> </div>
        </div>
        <div className="csw-option-result-item-text">
          {isQuiz && isCorrect && <IconCheck iconClassName="csw-i-success" />}
          {isQuiz && !isCorrect && <IconClose iconClassName="csw-i-danger" />}

          {/* Always include text, but hide visually when image is present */}
          <span className={classNames({ "sr-only": !!img })}>{text}</span>

          {/* Show image when present, aria-hidden b/c text is available to screen reader */}
          {img && <DecorativeImage className="csw-option-result-item-image" src={img} alt={imgAlt || text || ""} />}
        </div>
        <div className="csw-option-result-item-percent">{percent}%</div>
      </div>
      <div className={classNames("csw-option-result-item-answer", answeredClass)}>
        {answered && (
          <IconLeftCaret
            title={i18n.t("YOUR_ANSWER")}
            aria-label={i18n.t("YOUR_ANSWER")}
            role="img"
            aria-hidden="false"
          />
        )}
      </div>
    </div>
  );
};

OptionResultItem.propTypes /* remove-proptypes */ = {
  option: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
};

export default OptionResultItem;
